import { PortfolioSelectionWrapper } from 'portfolio/PortfolioSelectionWrapper';
import { AppSettingsState } from 'app/store/appSettings/AppSettingsState';
import State from 'store/State';
import { PortfolioSelectionDependencyType } from 'widgets/streaming/WidgetStreamConfig';

type PayloadBuilder<TPayload> = (
    portfolioSelection: PortfolioSelectionWrapper,
    widgetKey: string,
    appSettings: AppSettingsState,
    state: State
) => TPayload;

export function buildPortfolioSelectionDependentPayload<TPayload>(
    selectionDependencyType: PortfolioSelectionDependencyType,
    builder: PayloadBuilder<TPayload>,
    widgetKey: string,
    selection: PortfolioSelectionWrapper,
    appSettings: AppSettingsState,
    state: State
): TPayload | undefined {
    if (!selection) {
        return undefined;
    }
    const decorator = getSelectionDependencyTypeDecorator(
        selectionDependencyType,
        builder
    );
    return decorator(selection, widgetKey, appSettings, state);
}

function getSelectionDependencyTypeDecorator<TPayload>(
    selectionDependencyType: PortfolioSelectionDependencyType,
    builder: PayloadBuilder<TPayload>
): PayloadBuilder<TPayload | undefined> {
    switch (selectionDependencyType) {
        case PortfolioSelectionDependencyType.SingleSymbolQuantity:
            return singleSymbolQuantityDecorator<TPayload>(builder);
        case PortfolioSelectionDependencyType.AtLeastOneSymbolQuantity:
            return atLeastOneSymbolQuantityDecorator<TPayload>(builder);
        case PortfolioSelectionDependencyType.SingleSymbol:
            return singleSymbolDecorator<TPayload>(builder);
    }
    return builder;
}

function singleSymbolQuantityDecorator<TPayload>(
    builder: PayloadBuilder<TPayload>
): PayloadBuilder<TPayload | undefined> {
    return (portfolioSelection, widgetKey, appSettings, state) => {
        return portfolioSelection.selectedSymbolQuantities.length === 1
            ? builder(portfolioSelection, widgetKey, appSettings, state)
            : undefined;
    };
}

function atLeastOneSymbolQuantityDecorator<TPayload>(
    builder: PayloadBuilder<TPayload>
): PayloadBuilder<TPayload | undefined> {
    return (portfolioSelection, widgetKey, appSettings, state) => {
        return portfolioSelection.selectedSymbolQuantities.length > 0
            ? builder(portfolioSelection, widgetKey, appSettings, state)
            : undefined;
    };
}

function singleSymbolDecorator<TPayload>(
    builder: PayloadBuilder<TPayload>
): PayloadBuilder<TPayload | undefined> {
    return (portfolioSelection, widgetKey, appSettings, state) => {
        return portfolioSelection.selectedSymbol
            ? builder(portfolioSelection, widgetKey, appSettings, state)
            : undefined;
    };
}
